import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { authAPI } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("axentia_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await authAPI.verify();
      setUser({ username: res.data.username, role: res.data.role, full_name: res.data.full_name });
    } catch {
      localStorage.removeItem("axentia_token");
      localStorage.removeItem("axentia_username");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (username, password) => {
    const res = await authAPI.login(username, password);
    localStorage.setItem("axentia_token", res.data.token);
    localStorage.setItem("axentia_username", res.data.username);
    setUser({ username: res.data.username, role: res.data.role, full_name: res.data.full_name });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("axentia_token");
    localStorage.removeItem("axentia_username");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
